function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import DefaultProps from "./default-props";
import colors from "/styles/colors";
import { IFRAME_COMPONENT_RENDERED, IFRAME_LOADED, IFRAME_LOAD_ERROR } from "/constants/bigbrain-event-types";
import { withRouter } from "next/router";
import { StyledIframeComponent } from "./iframe.scss";
import { getDecodedParamFromQuery } from "utils/url";
const SRC = "src";
class IframeComponent extends PureComponent {
    componentDidMount() {
        var _window;
        const decodedSrc = getDecodedParamFromQuery((_window = window) === null || _window === void 0 ? void 0 : _window.location, SRC);
        this.setState({
            decodedSrc
        });
        this.trackIframeEvent(IFRAME_COMPONENT_RENDERED);
    }
    trackIframeEvent(kind) {
        const { src, router } = this.props;
        BigBrain("track", "homepage_iframe_tracking", {
            kind,
            placement: router.asPath,
            info1: src
        });
    }
    buildStyle() {
        const { height, borderColor, borderWidth } = this.props;
        const borderHexColor = colors[borderColor];
        return {
            height,
            border: `${borderWidth} ${borderHexColor} solid`
        };
    }
    render() {
        return /*#__PURE__*/ _jsx(StyledIframeComponent, {
            className: "iframe-core-component-wrapper",
            children: /*#__PURE__*/ _jsx("iframe", _object_spread({
                className: "iframe-core-component"
            }, this.buildIframeParams()))
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "iframeLoaded", ()=>{
            this.trackIframeEvent(IFRAME_LOADED);
        });
        _define_property(this, "iframeLoadingError", ()=>{
            this.trackIframeEvent(IFRAME_LOAD_ERROR);
        });
        _define_property(this, "buildIframeParams", ()=>{
            const { src, hideScrolling } = this.props;
            const { decodedSrc } = this.state;
            return {
                src: src || decodedSrc,
                scrolling: hideScrolling ? "no" : "auto",
                onLoad: this.iframeLoaded,
                onError: this.iframeLoadingError,
                style: this.buildStyle()
            };
        });
        this.state = {
            decodedSrc: null
        };
    }
}
export default withRouter(IframeComponent);
IframeComponent.defaultProps = DefaultProps;
